/** Chart palette for Guardians stats (AniOS night / transparent workbench). */

export interface ChartThemeColors {
  passed: string;
  raisedAlert: string;
  amber: string;
  volume: string;
  grid: string;
  axisLabel: string;
  selected: string;
  muted: string;
  textPrimary: string;
  tooltipBg: string;
}

export const CHART_COLORS: ChartThemeColors = {
  passed: "#34d399",
  raisedAlert: "#f87171",
  amber: "#fbbf24",
  volume: "#312e81",
  grid: "rgba(255, 255, 255, 0.06)",
  axisLabel: "#94a3b8",
  selected: "#818cf8",
  muted: "#64748b",
  textPrimary: "#f1f5f9",
  tooltipBg: "rgba(15, 23, 42, 0.94)",
};

/** @deprecated Use CHART_COLORS — Guardians stats run in night mode only. */
export const CHART_COLORS_DARK = CHART_COLORS;

/** @deprecated Use CHART_COLORS — Guardians stats run in night mode only. */
export const CHART_COLORS_LIGHT = CHART_COLORS;

export const LABEL_COLUMN_WIDTH = 148;
export const CHART_MARGIN = { top: 12, right: 52, bottom: 28, left: 48 };
export const BAR_RADIUS = 4;
export const CHART_LEGEND_GAP = 8;

export const STATS_CARD_CLASS =
  "rounded-2xl border border-white/10 bg-slate-900/30 ring-1 ring-inset ring-white/5";

export const STATS_KPI_CLASS =
  "rounded-xl border border-white/10 bg-slate-900/40";

export function passRateColor(ratePercent: number): "emerald" | "amber" | "red" {
  if (ratePercent >= 90) return "emerald";
  if (ratePercent >= 75) return "amber";
  return "red";
}

export function formatPercent(value: number, digits = 1): string {
  return `${value.toFixed(digits)}%`;
}

export function slugifyTitle(title: string): string {
  return title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

export function kindBadgeClass(kind: "llm" | "signal" | "ignore"): string {
  if (kind === "llm") return "bg-indigo-500/20 text-indigo-200";
  if (kind === "signal") return "bg-red-500/20 text-red-200";
  return "bg-slate-500/20 text-slate-300";
}

export function kindLabel(kind: "llm" | "signal" | "ignore"): string {
  if (kind === "llm") return "LLM";
  if (kind === "signal") return "Signal";
  return "Ignore";
}

export function kindBarColor(kind: "llm" | "signal" | "ignore", theme: ChartThemeColors): string {
  if (kind === "signal") return theme.raisedAlert;
  if (kind === "llm") return theme.selected;
  return theme.muted;
}
